import { withT } from "neetocommons/react-utils";
import { Help, Right } from "neetoicons";
import { Dropdown } from "neetoui";

const { MenuItem } = Dropdown;

const MenuButton = withT(({ t, tReady: _tReady, ...otherProps }) => (
  <MenuItem.Button
    className="neeto-molecules-menu-sublist__item-btn"
    data-testid="help-menu-button"
    prefix={<Help size={18} />}
    style="text"
    suffix={<Right className="rtl:scale-x-[-1]" size={18} />}
    {...otherProps}
  >
    {t("neetoMolecules.sidebar.help")}
  </MenuItem.Button>
));

export default MenuButton;
